module.exports = __webpack_public_path__ + "img/circleWhite.e1951a7a.svg";